export interface IListMedicationRoutesEndpointResponse {
  list: {
    id: string;
    title: string;
  }[];
}

export const listMedicationRoutesEndpoint = () => '/medications/routes';
